import * as React from 'react';
import Fonts from '../constants/Fonts';
import { LightBackgroundView, Text } from './Themed';

export default function SectionHeader({ title }) {
    return <LightBackgroundView>
        <Text style={{ ...Fonts.subtitle, paddingVertical: 6, paddingHorizontal: 10 }}>{title}</Text>
    </LightBackgroundView>
}
